import { DiscountInput, DiscountType } from './discount'
import { PaymentMethod } from './payment'
import { Commission } from './reports/sales-and-commission'

export enum OrderType {
    MEMBERSHIP = 'MEMBERSHIP',
    MEMBERSHIP_RENEWAL = 'MEMBERSHIP_RENEWAL',
    PRODUCT = 'PRODUCT',
    SERVICE = 'SERVICE',
}

export enum OrderPaymentMethod {
    BANK_TRANSFER = "BANK_TRANSFER",
    CARD = "CARD",
    CASH = "CASH"
}

export type OrderPaymentApiOutput = {
    id: string
    locationId: string
    lookupId: string
    paymentMethod: PaymentMethod
    paymentIntegrationId: string
    paymentProcessorResponse: string
    amount: number
    amountRefunded?: number
}

export type OrderLookup = {
    service?: string
}

export type OrderPayment = {
    id: string
    location_id?: string
    payment_method: PaymentMethod
    payment_integration: {
        id: string
    }
    amount: number
    amount_refunded?: number
}

export type OrderApiOutput = {
    id: string
    adhocDiscountType?: DiscountType
    adhocDiscount?: number
    clientId: string
    couponId?: string
    couponCode?: string
    fullyPaid: boolean
    lookupId: string
    membershipClientId?: string
    payments: OrderPaymentApiOutput[]
    totalAmount?: number
}

export type Order = {
    id?: string
    coupon?: {
        id: string
        code: string
    }
    discount?: DiscountInput
    fully_paid: boolean
    lookup_ref?: OrderLookup
    membership_client_id?: string
    payments?: OrderPayment[]
    tax_overide?: number
    total_amount?: number
    clientId?: string
}

export type OrderList = {
    client_id?: string
    client_email?: string
    commission: Commission
    commission_amount?: number
    commission_percentage?: number
    coupon: string
    coupon_id: string
    date: string
    id: string
    item: string
    lookup_id?: string
    membership_client_id?: string
    payment_amount?: number
    payment_intent?: string
    payment_method: OrderPaymentMethod
    quantity: number
    sold_by?: string
    status: boolean
    time: string
    total: number
    type: OrderType
}

export type OrderDTO = {
    clientId?: string
    clientEmail?: string
    commission: Commission
    commissionAmount?: number
    commissionPercentage?: number
    couponCode: string
    couponId: string
    createdAt: string
    date: string
    fullyPaid: boolean
    id: string
    item: string
    lookupId: string
    membershipClientId: string
    paymentAmount?: number
    paymentMethod: OrderPaymentMethod
    payments: OrderPaymentApiOutput[]
    quantity: number
    status: string
    soldBy: string
    time: string
    total: string
    totalAmount: number
    type: OrderType
}

export function mapToOrderDTO(order: OrderList): OrderDTO {
    return {
        clientId: order.client_id,
        clientEmail: order.client_email,
        commission: order.commission,
        commissionAmount: order.commission_amount,
        commissionPercentage: order.commission_percentage,
        couponCode: order.coupon,
        couponId: order.coupon_id,
        createdAt: order.date,
        fullyPaid: order.status,
        id: order.id,
        lookupId: order.lookup_id,
        membershipClientId: order.membership_client_id,
        paymentAmount: order.payment_amount,
        paymentMethod: order.payment_method,
        quantity: order.quantity,
        soldBy: order.sold_by,
        totalAmount: order.total,
        type: order.type
    } as OrderDTO
}
